import { CountOnPage } from './types';

export const DEFAULT_COUNTS_ON_PAGE: CountOnPage[] = [
    {
        label: '20',
        value: 20,
    },
    {
        label: '50',
        value: 50,
    },
    {
        label: '100',
        value: 100,
    },
];

export const PAGINATION_COUNTS_ON_PAGE_THREE_COLUMNS: CountOnPage[] = [
    {
        label: '9',
        value: 9,
    },
    {
        label: '27',
        value: 27,
    },
    {
        label: '81',
        value: 81,
    },
];

export const DEFAULT_COUNT_ON_PAGE = DEFAULT_COUNTS_ON_PAGE[0];
export const DEFAULT_COUNT_ON_PAGE_THREE_COLUMNS = PAGINATION_COUNTS_ON_PAGE_THREE_COLUMNS[0];
export const ENDLESS_PAGINATION = -1;
